import { ErrorViewModel }                       from '../../..';
import { DialogEntity,
         IConversationState,
         NotificationEntity }                   from '../..';


export interface IConversationGetters {
  isRequestInProgress(state: IConversationState): boolean;
  isSatRequestInProgress(state: IConversationState): boolean;
  isLatestRequestSucceed(state: IConversationState): boolean;
  latestError(state: IConversationState): ErrorViewModel | undefined;
  currentDialog(state: IConversationState): DialogEntity | undefined;
  getNotifications(state: IConversationState) : NotificationEntity[];
  getUnseenNotifications(state: IConversationState) : NotificationEntity[];
  getNotificationsToShow(state: IConversationState) : NotificationEntity[];
}

export const ConversationGetters: IConversationGetters = {
  /**
   * Indicates whether a server request is in progress or not.
   * @returns TRUE when the server has not sent a response to the latest request, FALSE otherwise.
   */
  isRequestInProgress(state: IConversationState): boolean {
    return state.isLoading;
  },
  /**
   * Indicates whether a server request for a satisfaction user feedback is in progress or not.
   * @returns TRUE when the server has not sent a response to the latest request, FALSE otherwise.
   */
   isSatRequestInProgress(state: IConversationState): boolean {
    return state.isSatReqLoading;
  },
  /**
   * Indicates whether latest user's request is succeed.
   * @returns TRUE when the server has sent a succeeded response to the latest request, FALSE otherwise.
   */
  isLatestRequestSucceed(state: IConversationState): boolean {
    return state.isRequestSucceed;
  },
  /**
   * Gets the an instance of ErrorViewModel associated to the latest action error.
   */
  latestError(state: IConversationState): ErrorViewModel | undefined {
    return state.error;
  },
  /**
   * Gets the current dialog associated to the current conversation session.
   */
  currentDialog(state: IConversationState): DialogEntity | undefined {
    return (state.currentConversation) ? state.currentConversation.currentDialog : undefined;
  },
  getNotifications(state: IConversationState): NotificationEntity[] {
    return state.notifications;
  },
  getUnseenNotifications(state: IConversationState):NotificationEntity[] {
    return state.notifications.filter(n => !n.seen)
  },
  getNotificationsToShow(state: IConversationState): NotificationEntity[]{
    return state.notifications.filter(n => n.toShow)
  }
};
